"use client";

import { Button } from "@pex/ui-web";
import { Check, Share2 } from "lucide-react";
import { useState } from "react";

interface ShareButtonsProps {
  title: string;
  url: string;
}

export function ShareButtons({ title, url }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;

  async function handleShare() {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // User cancelled the share sheet — do nothing
      }
      return;
    }
    // Fallback: copy the URL to clipboard
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable (e.g. non-HTTPS) — silently ignore
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button onClick={handleShare} size="sm" variant="outline">
        {copied ? (
          <Check aria-hidden="true" className="h-4 w-4" />
        ) : (
          <Share2 aria-hidden="true" className="h-4 w-4" />
        )}
        {copied ? "Copied!" : "Share"}
      </Button>
      <Button asChild size="sm" variant="outline">
        <a href={whatsappUrl} rel="noopener noreferrer" target="_blank">
          {/* biome-ignore lint/performance/noImgElement: decorative icon inside button — next/image adds a span wrapper that breaks flex alignment */}
          <img
            alt=""
            aria-hidden="true"
            className="h-4 w-4"
            height={16}
            src="/icons/social/whatsapp.svg"
            width={16}
          />
          WhatsApp
        </a>
      </Button>
    </div>
  );
}
